import type { ChipSize } from '@/core/components/chip/chip';
import type { QuickFilterGroup } from '@/features/filter/quick-filter/quick-filter-service';

import ResetIcon from '@/assets/icons/reset';
import QuickFilterChip from '@/features/filter/quick-filter/quick-filter/quick-filter-chip';

export type QuickFilterV1Props = {
    chipLargeIcons?: boolean;
    chipRounded?: boolean;
    chipSize?: ChipSize;
    closeButtonSize?: number;
    fullWidth?: boolean;
    isScrollable?: boolean;
    onDeselect: (group: QuickFilterGroup) => void;
    onFilterReset?: () => void;
    onSelect: (group: QuickFilterGroup) => void;
    padding?: 'padding-0' | 'padding-16';
    quickFilterCollection: Array<QuickFilterGroup>;
    showResetButton?: boolean;
    wrap?: 'nowrap' | 'wrap';
};

export default function QuickFilter({
    chipLargeIcons,
    chipRounded,
    chipSize,
    closeButtonSize,
    fullWidth = true,
    isScrollable = true,
    onDeselect,
    onFilterReset,
    onSelect,
    padding = 'padding-16',
    quickFilterCollection,
    showResetButton = false,
    wrap = 'nowrap',
}: QuickFilterV1Props) {
    return (
        <div className={`overflow-hidden ${fullWidth ? 'full-width' : ''}`}>
            <div
                className={`align-center gap-horizontal no-scrollbar ${padding} ${padding === 'padding-16' ? '-margin-top-16 -margin-bottom-16' : ''} ${wrap} ${isScrollable ? 'overflow-x' : ''}`}
            >
                {quickFilterCollection.map((group, index) => (
                    <QuickFilterChip
                        closeButtonSize={closeButtonSize}
                        group={group}
                        key={`${group.title}-${index}`}
                        largeIcons={chipLargeIcons}
                        onDeselect={onDeselect}
                        onSelect={onSelect}
                        rounded={chipRounded}
                        size={chipSize}
                    />
                ))}

                {showResetButton && quickFilterCollection.length > 0 && (
                    <button
                        className={'flex-center link font-size-12 gap-4'}
                        onClick={onFilterReset}
                    >
                        <ResetIcon
                            height={14}
                            width={14}
                        />
                        zurücksetzen
                    </button>
                )}
            </div>
        </div>
    );
}
